import React, {useEffect, useState} from 'react';
import styles from './PlatformCard.module.scss';
import moment from "moment";
import {$t} from "../../../helpers/translator";
import {BiWifi, BiWifiOff} from "react-icons/bi";
import Tooltip from "../Tooltip/Tooltip";
import {useHistory} from "react-router-dom";
import PlatformUsagePieChart from "../../PlatformUsagePieChart/PlatformUsagePieChart";
import Loader from "../Loader/Loader";


const PlatformCard = (props) => {
    const history = useHistory()
    const [online, setOnline] = useState(true);

    useEffect(() => {
        // console.log('propsprops', props)
    })

    function goToClinic(e, id) {
        e.stopPropagation();
        history.push(`/clinic/${props.platform.clinic_id}`)
    }

    function goToPlatform() {
        history.push(`/equipment/platform/${props.platform.id}`)
    }

    return (
        // <Link to={`platform/${this.state.id}`}>
        <div className={styles.container} onClick={() => goToPlatform()}>
            {props.platform ?
                <>
                    <div className={styles.topPart}>
                        <div className={styles.name}>{props.platform.machine_name}</div>
                        <div className={styles.id}>{props.platform.machine_id}</div>
                    </div>
                    {/*<div className={styles.goToSymbol} onClick={() => goToPlatform()}>*/}
                    {/*    <Tooltip content={$t('global.machines.goToPlatformPage')}>*/}
                    {/*        <IoOpenOutline style={{fontSize: '20px'}}/>*/}
                    {/*    </Tooltip>*/}
                    {/*</div>*/}

                    <div className={styles.dataRow}>
                        <div className={styles.temperature}>
                            {
                                props.platform.temperature_avg && props.platform.temperature_avg !== 0 ?
                                    props.platform.temperature_avg + '°C'
                                    :
                                    ''
                            }
                        </div>
                        <div className={styles.online}>
                            {props.platform.is_online === true &&
                                <Tooltip
                                    content={`${$t('global.machines.lastConnected')}: ${props.platform.last_connected}`}>
                                    <BiWifi style={{
                                        color: '#67a14b',
                                        fontSize: '20px'
                                    }}/>
                                </Tooltip>
                            }
                            {props.platform.is_online === false &&
                                <Tooltip
                                    content={`${$t('global.machines.lastConnected')}: ${props.platform.last_connected}`}>
                                    <BiWifiOff style={{
                                        color: '#DC3545',
                                        fontSize: '20px'

                                    }}/>
                                </Tooltip>
                            }
                            {props.platform.is_online === null &&
                                <Tooltip
                                    content={`${$t('global.machines.lastConnected')}: Unknown`}>
                                    <BiWifiOff style={{
                                        color: '#FFC107',
                                        fontSize: '20px'

                                    }}/>
                                </Tooltip>
                            }
                        </div>
                    </div>
                    <div className={styles.mainRow}>
                        {
                            props.platform.usage && props.platform.usage.percentage ?
                                <div className={styles.pieChartContainer}>
                                    <PlatformUsagePieChart size={(props.small ? 80 : 100)} data={{
                                        lasing: props.platform.usage.percentage.lasing,
                                        treatment: props.platform.usage.percentage.treatment,
                                        online: props.platform.usage.percentage.online,
                                    }}/>
                                </div>
                                :
                                null
                        }
                        <div className={styles.imageContainer}>
                            <img src={props.platform.image} className={(props.small ? styles.imageSmall : styles.image)}
                                 alt={props.platform.machine_type}/>

                        </div>
                    </div>
                    {
                        props.userType > 2 && props.platform.clinic_name ?
                            <div className={styles.goToClinicContainer}>
                                <div className={styles.goToClinic}
                                     onClick={(e) => goToClinic(e, props.platform.clinic_id)}>
                                    <Tooltip content={$t('global.machines.goToClinicPage')}>
                                        <div>
                                            {props.platform.clinic_name}
                                        </div>
                                    </Tooltip>
                                </div>
                            </div>
                            :
                            null
                    }

                    {
                        props.userType === 5 && !props.platform.clinic_name ?
                            <div className={styles.goToClinicContainer}>
                                <Tooltip content={$t('global.machines.platformDetached')}>
                                    <div className={styles.detached}>
                                        {$t('global.machines.detached')}
                                    </div>
                                </Tooltip>
                            </div>
                            :
                            null
                    }

                    <div className={styles.bottomPart}>
                        {moment(props.platform.connected_to_clinic).isValid() ?
                            <Tooltip
                                content={moment(props.platform.connected_to_clinic).format('LLL')}>
                                Added {moment(props.platform.connected_to_clinic).fromNow()}
                            </Tooltip>
                            :
                            <div>N/A</div>
                        }
                    </div>

                </>
                :
                <Loader/>
            }

        </div>
        // </Link>
    );
    // }
}

// export default PlatformCard;
// const mapStateToProps = (state) => ({
//     state: state
// });
//
// export default connect(mapStateToProps)(PlatformCard);

PlatformCard.defaultProps = {
    platform: null,
    userType: 2
}

export default PlatformCard;